import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getDefaultDate } from '../device-monitoring-search/device-monitoring-search.component';
import { IDeviceMonitoringData } from '../device-monitoring/devicemonitoring.component';
import { MonitoringService } from '../services/monitoring.service';

@Component({
  selector: 'dcc-device-profile-page',
  templateUrl: './device-profile-page.component.html',
  styleUrls: ['./device-profile-page.component.scss'],
})
export class DeviceProfilePageComponent implements OnInit {
  serialNumber = '';
  startDate = new Date(getDefaultDate(new Date(new Date().getTime() - (86400000 * 7))));
  endDate = new Date(getDefaultDate(new Date()));

  error = false;
  loading = true;

  deviceData: IDeviceMonitoringData;

  private returnUrl = '/insights/devices';
  private returnQueryParams: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private monitoringService: MonitoringService,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit() {
    this.serialNumber = this.route.snapshot.paramMap.get('serialNumber') || '';

    const nav = this.router.getCurrentNavigation() ?? history.state;
    if (nav?.returnUrl) {
      this.returnUrl = nav.returnUrl;
    }
    if (nav?.returnQueryParams) {
      this.returnQueryParams = nav.returnQueryParams;
    }
    const state = history.state as any;
    if (state?.returnUrl) {
      this.returnUrl = state.returnUrl;
    }
    if (state?.returnQueryParams) {
      this.returnQueryParams = state.returnQueryParams;
    }

    await this.loadData();
  }

  goBack(): void {
    this.router.navigate([this.returnUrl], {
      queryParams: this.returnQueryParams,
    });
  }

  async loadData(): Promise<void> {
    this.error = false;
    this.loading = true;
    this.cdr.detectChanges();

    try {
      const data = await this.monitoringService.getMonitoringData(
        [this.serialNumber],
        this.startDate,
        this.endDate,
      );
      this.deviceData = data.get(this.serialNumber);
    } catch (error) {
      console.error(error);
      this.error = true;
    } finally {
      this.loading = false;
      this.cdr.detectChanges();
    }
  }
}
